import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import NavBar from "./NavBar/NavBar";
import Logo from "../../UI/Logo/Logo";
import { LOGO_THEME } from "../../../constants/logo";

const Header = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);
  return (
    <header
      className="
        py-8
        px-6
        md:px-16
        border-b
        border-light-gray
        flex
        flex-wrap
        justify-between
        items-center
      "
    >
      <div className="grow py-1 flex justify-between lg:justify-start flex-wrap items-center gap-24 ">
        <Logo theme={LOGO_THEME.DARK} />
        <NavBar />
      </div>
      <NavLink
        to={isAuthenticated ? "/categories" : "/login"}
        className="hidden lg:block p-4 rounded-lg text-white font-bold text-2xl bg-dark-blue"
      >
        {isAuthenticated ? "تصفح الأقسام" : "تسجيل الدخول"}
      </NavLink>
    </header>
  );
};

export default Header;
